import React, { useState } from 'react';

import { Button, Container, makeStyles, Typography } from '@material-ui/core';

import { DOCX, IMAGE, PDF, TEXT } from '../../models/Resource';
import { megaBytesToBytes, sanitizeFileName } from '../../utils/files';

const useStyles = makeStyles(() => ({
  typographyError: {
    color: 'red',
    fontSize: '12px',
    lineBreak: 'anywhere',
    lineHeight: '18px',
    marginTop: '4px',
  },
}));

export default function PersonalizedVideoFilesRadiologyReport({ onCancel, onReportUpload }) {
  const classes = useStyles();
  const [sizeError, setSizeError] = useState(null);

  const handleReportChange = (event) => {
    setSizeError(null);
    const file = sanitizeFileName(event.target.files[0]);

    if (file.type.includes(IMAGE) && file.size > megaBytesToBytes(5)) {
      setSizeError('Images should not exceed 5MB.');
      return;
    }

    const isDocType = file.type.includes(DOCX) || file.type.includes(PDF) || file.type.includes(TEXT);

    if (isDocType && file.size > megaBytesToBytes(10)) {
      setSizeError('Documents files should not exceed 10MB.');
      return;
    }

    const files = [...(event.target.files || [])];
    onReportUpload(files);
  };

  return (
    <Container style={{ background: 'white', width: '424px' }}>
      <div style={{ paddingBlock: '20px' }}>
        <div style={{ marginBottom: '16px' }}>
          <Typography className="page-header mb-1">Upload Radiology Report</Typography>
        </div>

        <div style={{ marginBottom: '16px' }}>
          <Typography>
            The official radiology report is <span style={{ fontWeight: 'bold' }}>REQUIRED</span> in order for Mediphany to generate your video report. If you have the official
            report, click <span style={{ fontWeight: 'bold' }}>Proceed</span> to upload the report. If you don&lsquo;t have the report, click{' '}
            <span style={{ fontWeight: 'bold' }}>Cancel- I don&lsquo;t have the report</span>.
            <br />
            <br />
            If you don&lsquo;t have your official radiology report, please note that you are legally entitled to get it from the site where you were scanned. You can contact them
            to obtain the report.
            {sizeError && <Typography className={classes.typographyError}>{sizeError}</Typography>}
          </Typography>
        </div>

        <div style={{ alignItems: 'center', display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between' }}>
          <Button variant="outlined" color="primary" onClick={onCancel} style={{ marginRight: '8px', marginTop: '4px' }}>
            Cancel - I don&lsquo;t have the report
          </Button>

          <span style={{ marginTop: '4px' }}>
            <input onChange={handleReportChange} hidden multiple id="raised-button-report" type="file" accept=".pdf,.jpg,.jpeg,.tiff,.png,.txt,.rtf,.doc,.docx" />
            <label htmlFor="raised-button-report">
              <Button variant="contained" component="span" color="primary">
                Proceed
              </Button>
            </label>
          </span>
        </div>
      </div>
    </Container>
  );
}
